module.exports = __webpack_public_path__ + "img/2.f3fc4153.png";